module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/babel-runtime/helpers/object-without-properties.js
// module id = 449
// module chunks = 168707334958949